import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/fresh-ingredients/components/FreshIngredientsInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/Header.tsx");
